export class EmployeeStatusType {
    id = null;
    name = null;
    code = null;
}